export const POPOUT_ANIMATION_MS = 350

export const MODAL_ANIMATION_MS = 300

export const PROMOCODE_MAX_LENGTH = 24
